"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_ERRORS = void 0;
exports.MAX_ERRORS = 20;
